<footer [class]="footerClass">
	@if (!useAltFooter) {
		<div class="container-fluid main-footer">
			<div class="row maxwidth-1280 mx-auto">
				<div class="col-7 col-sm-6 col-md-7 col-lg-6 mb-5 mb-lg-0">
					<p class="mb-4"><img [attr.src]="logo" [attr.alt]="agentName" class="img-fluid" /></p>
					<p class="light-text">
						Enabled by <a href="https://powerkiosk.com" target="_blank" class="semibold-text" id="footerPkLink">Power Kiosk</a>
					</p>
				</div>
				<div class="col-12 col-md-6 col-lg-3 mb-5 mb-md-0">
					<h4 class="mb-4">Contact us</h4>
					<p class="light-text">{{ address }}</p>
					<p class="light-text">
						<a href="tel:{{ promoCode?.agent.eCommerceWebsite?.contactPhoneNumber }}" id="footerPhoneNumber">{{
							promoCode?.agent.eCommerceWebsite?.contactPhoneNumber | phone: promoCode?.agent.eCommerceWebsite?.contactPhoneNumberCountry?.id
						}}</a>
					</p>
					<p>
						<a [attr.href]="'mailto:' + promoCode.agent.eCommerceWebsite?.contactEmail" class="light-text" id="footerNavEmailLink">{{
							promoCode.agent.eCommerceWebsite?.contactEmail
						}}</a>
					</p>
				</div>
				<div class="col-12 col-md-6 col-lg-3">
					<h4 class="mb-4">Pages</h4>
					<p><a href="#howItWorks" (click)="goSmartBegin()" class="light-text" id="footerNavHowItWorks">How it works</a></p>
					<p><a href="#whoWeAre" (click)="goSmartBegin()" class="light-text" id="footerNavWhoWeAre">Who we are</a></p>
					<p><a href="#faq" (click)="goSmartBegin()" class="light-text" id="footerNavFaq">FAQ</a></p>
				</div>
			</div>
			<div class="row maxwidth-1280 mx-auto">
				<div class="col mt-4">
					<p class="font-size-075 mb-0">
						* Savings estimate is based on the 85th percentile of {{ agentName }} users who switched to a new supply rate vs the utility default,
						annualized from estimated full term supply contract savings.
					</p>
					<hr />
				</div>
			</div>
			<div class="row maxwidth-1280 mx-auto mt-4">
				<div class="col">
					<p class="font-size-085 light-text"><a [routerLink]="['/privacy-policy']" id="footerPrivacyPolicy">Privacy Policy</a></p>
				</div>
				<div class="col-auto text-end">
					<p class="font-size-085 light-text">&copy; {{ year }} All Rights Reserved</p>
				</div>
			</div>
		</div>
	} @else {
		<div class="container-fluid">
			<div class="row d-flex align-items-center">
				<div class="col">
					<div class="row d-flex align-items-center">
						<div class="col-auto pe-1">
							<img [attr.src]="logo" [attr.alt]="agentName" class="footer-ep-icon" />
						</div>
						<div class="col enabled-by-text ps-2">
							Enabled by <strong><a href="https://powerkiosk.com" target="_blank" class="reverse-deco" id="footerPkLink">PowerKiosk</a></strong>
						</div>
					</div>
				</div>
				<div class="col-auto font-size-085 light-text">
					<a [routerLink]="['/privacy-policy']" target="_blank" class="reverse-deco" id="footerPrivacyPolicy">Privacy Policy</a>
				</div>
			</div>
		</div>
	}
</footer>
